import React, { useEffect, useState } from "react";
import { fetchReportInteractions } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface InteractionsTotalMetricState {
  title?: string;
  data?: number;
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
  byType?: boolean;
  type?: string;
  readOnly?: boolean;
  active?: boolean;
  onHandleClick?: any;
}

// 3 options:
// by Type = false && type = undefined -> all interactions
// by Type = true && type = undefined -> interactions by all types
// by Type = false && type = "some type" -> interactions by specific type
export const InteractionsTotalMetric = ({
  title,
  data,
  useDatePicker = false,
  startDate,
  endDate,
  byType = false,
  type,
  readOnly = true,
  active,
  onHandleClick,
}: InteractionsTotalMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [current, setCurrent] = useState<number | null>();
  const [currentTitle, setCurrentTitle] = useState<string>(title ?? "");
  const [currentTypes, setCurrentTypes] = useState<any[]>([]);
  const [selectedType, setSelectedType] = useState<string | undefined>(type);

  useEffect(() => {
    const fetchData = async () => {
      if (data !== undefined && data >= 0) {
        setCurrent(data);
        setIsLoading(false);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getInteractions(start!, end!);
      }
    };

    fetchData();
  }, [startDate, endDate, data, byType]);

  const getInteractions = async (start: string, end: string) => {
    fetchReportInteractions(start, end)
      .then(async (res: any) => {
        const data = res[0].data || {};

        //all
        if (!byType && !type) {
          setCurrentTitle("All Interactions");
          setCurrent(data.total || 0);
          setIsLoading(false);
          return;
        }
        if (byType) {
          let noteTypes = data.note_type_counts || [];
          const filteredNoteTypes = noteTypes?.filter((t: any) => t?.type !== "system");

          const noteTypeExists = filteredNoteTypes.find((nt: any) => nt.name === selectedType);
          var currentSelected = "";
          if (noteTypeExists) {
            currentSelected = noteTypeExists?.name;
            setSelectedType(currentSelected);
            setCurrentTitle(currentSelected);
          } else {
            currentSelected = filteredNoteTypes[0]?.name;

            setSelectedType(currentSelected);
            setCurrentTitle(currentSelected);
          }
          setCurrentTypes(filteredNoteTypes);
          setCurrent(filteredNoteTypes.filter((note: any) => note.name === currentSelected).count || 0);
          setIsLoading(false);
          return;
        }
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  if (readOnly) {
    return (
      <SingleCardMetric
        title={currentTitle ? currentTitle : "Interactions"}
        total={current}
        isLoading={isLoading}
        types={currentTypes}
        selectedType={selectedType}
        onSelectType={setSelectedType}
      />
    );
  } else {
    return (
      <SingleCardMetric
        title={currentTitle}
        total={current}
        isLoading={isLoading}
        types={currentTypes}
        selectedType={selectedType}
        onSelectType={setSelectedType}
        onHandleClick={onHandleClick}
        cursor={true}
        active={active}
      />
    );
  }
};
